import { createContext, useContext } from 'react'
import { AssetCategory } from './PoolContext'

export interface Asset {
  uuid?: string,
  issuer_uuid: string,
  asset_category: AssetCategory,
  name: string,
  asset_type: string,
  asset_status_name?: string
  date_created?: string,
  currency_cd: string,
  issuer_name: string,
  extra_info: any,
  comment?: string
}

export interface AssetCreation {
  uuid?: string,
  issuer_uuid?: string,
  asset_category: AssetCategory,
  name: string,
  asset_type: string,
  currency_cd: string,
  issuer_name: string,
  extra_info: any
}

export const defaultAsset: Asset = {
  //uuid: 0,
  issuer_uuid: "",
  name: "",
  date_created: "",
  currency_cd: "",
  issuer_name: "",
  extra_info: {},
  asset_category: '',
  asset_type: '',
  asset_status_name: '',
  comment: ''
}


/* HORSE EXTRA INFO */

export interface SportResult {
  rank: string,
  year: number,
  rider: string,
  height: string,
  competition: string
}

export const defaultSportResult: SportResult = {
  rank: "",
  year: 0,
  rider: "",
  height: "",
  competition: "",
}

export interface PrizeEarnings {
  year: number,
  prize: string
}

export const defaultPrizeEarnings: PrizeEarnings = {
  year: 0,
  prize: "",
}

export interface HorseExtraInfo {
  age: number,
  name: string,
  sire: string,
  color: string,
  rider: string,
  gender: string,
  madame: string,
  breeder: string,
  est_value: string,
  discipline: string,
  fei_number: string,
  best_result: string,
  description: string,
  date_of_birth: number,
  sport_results: SportResult[],
  total_winning: string,
  prize_earnings: PrizeEarnings[],
  rating_scuderia: string
}

export const defaultHorseExtraInfo: HorseExtraInfo = {
  age: 0,
  name: '',
  sire: '',
  color: '',
  rider: '',
  gender: '',
  madame: '',
  breeder: '',
  est_value: '',
  discipline: '',
  fei_number: '',
  best_result: '',
  description: '',
  date_of_birth: 0,
  sport_results: [],
  total_winning: '',
  prize_earnings: [],
  rating_scuderia: ''
}

export interface ArtInvestingExtraInfo {
  art_location: string[],
  artist: string,
  artwork_title: string,
  description: string,
  estimate: string,
  insurance: string,
  owners: string[],
  signed: string,
  size: string,
  subtype: string,
  technique: string,
  year: string
}

export const defaultArtInvestingExtraInfo: ArtInvestingExtraInfo = {
  art_location: [],
  artist: '',
  artwork_title: '',
  description: '',
  estimate: '',
  insurance: '',
  owners: [],
  signed: '',
  size: '',
  subtype: '',
  technique: '',
  year: ''
}

/* ART LENDING EXTRA INFO */
export interface ArtLendingExtraInfo {
  art_location: string[],
  artist: string,
  artwork_title: string,
  description: string,
  estimate: string,
  insurance: string,
  interest_structure: string,
  loan_amount: string,
  owners: string[],
  right_of_first_refusal: string,
  signed: string,
  size: string,
  subtype: string,
  technique: string,
  term_in_months: string,
  time_span: string,
  year: string
}

export const defaultArtLendingExtraInfo: ArtLendingExtraInfo = {
  art_location: [],
  artist: '',
  artwork_title: '',
  description: '',
  estimate: '',
  insurance: '',
  interest_structure: '',
  loan_amount: '',
  owners: [],
  right_of_first_refusal: '',
  signed: '',
  size: '',
  subtype: '',
  technique: '',
  term_in_months: '',
  time_span: '',
  year: ''
}



/* IF EXTRA INFO */

export interface IfIrr {
  target_moic?: string,
  target_gross_irr: string,
  target_cash_yield?: string,
  distribution_policy: string
}

export const defaultIfIrr: IfIrr = {
  target_moic: "",
  target_gross_irr: "",
  target_cash_yield: "",
  distribution_policy: ""
}

export interface IfOther {
  IFM: string,
  auditor: string,
  custodian: string,
  reporting: string,
  distributor: string,
  gp_clawback?: string,
  hurdle_rate?: string,
  administrator: string,
  nav_frequency: string,
  share_classes: string,
  incentive_fees: string,
  general_partner?: string,
  legal_counselor?: string,
  legal_structure?: string,
  management_fees: string,
  sub_distributor: string,
  portfolio_manager: string,
  type_of_waterfall?: string,
  subsequent_subscriptions: string
}

export const defaultIfOther: IfOther = {
  IFM: "",
  auditor: "",
  custodian: "",
  reporting: "",
  distributor: "",
  gp_clawback: "",
  hurdle_rate: "",
  administrator: "",
  nav_frequency: "",
  share_classes: "",
  incentive_fees: "",
  general_partner: "",
  legal_counselor: "",
  legal_structure: "",
  management_fees: "",
  sub_distributor: "",
  portfolio_manager: "",
  type_of_waterfall: "",
  subsequent_subscriptions: ""
}

export interface IfOverview {
  deal_type: string,
  fund_name: string,
  target_fund_size: string,
  investment_period?: string,
  risk_return_characteristics: string,
  target_allocation: string,
  investment_strategy_description?: string
}

export const defaultIfOverview: IfOverview = {
  deal_type: "",
  fund_name: "",
  target_fund_size: "",
  investment_period: "",
  risk_return_characteristics: "",
  target_allocation: "",
  investment_strategy_description: ""
}

export interface IfFundTerms {
  ramp_up: string,
  fund_term: string,
  final_close: string,
  first_close: string,
  capital_calls: string,
  investment_period: string,
  capital_restitutions: string
}

export const defaultIfFundTerms: IfFundTerms = {
  ramp_up: "",
  fund_term: "",
  final_close: "",
  first_close: "",
  capital_calls: "",
  investment_period: "",
  capital_restitutions: ""
}

export interface IfPrivateDebtCharacteristics {
  covenant: string,
  deal_currency: string,
  fund_currency: string,
  average_rating: string,
  loans_or_bonds: string,
  minimum_rating: string,
  number_of_deals: string,
  borrower_profile: string,
  target_deal_size: string,
  floating_or_fixed: string,
  type_of_collateral: string,
  speed_of_deployment: string,
  target_company_size: string,
  bullet_or_amortizing: string,
  primary_or_secondary: string,
  sponsor_or_corporate: string,
  typical_loan_to_value: string,
  expected_term_per_deal: string,
  max_average_net_leverage: string,
  max_typical_term_per_deal: string
}

export const defaultIfPrivateDebtCharacteristics: IfPrivateDebtCharacteristics = {
  covenant: "",
  deal_currency: "",
  fund_currency: "",
  average_rating: "",
  loans_or_bonds: "",
  minimum_rating: "",
  number_of_deals: "",
  borrower_profile: "",
  target_deal_size: "",
  floating_or_fixed: "",
  type_of_collateral: "",
  speed_of_deployment: "",
  target_company_size: "",
  bullet_or_amortizing: "",
  primary_or_secondary: "",
  sponsor_or_corporate: "",
  typical_loan_to_value: "",
  expected_term_per_deal: "",
  max_average_net_leverage: "",
  max_typical_term_per_deal: ""
}

export interface IfPrivateEquityCharacteristics {
  warranty: string,
  co_investment: string,
  deal_currency: string,
  fund_currency: string,
  target_sectors: string,
  number_of_deals: string,
  target_deal_size: string,
  primary_secondary: string,
  speed_of_deployment: string,
  target_company_size: string,
  portfolio_company_profile: string,
  typical_stake_in_portfolio_companies: string
}

export const defaultIfPrivateEquityCharacteristics: IfPrivateEquityCharacteristics = {
  warranty: "",
  co_investment: "",
  deal_currency: "",
  fund_currency: "",
  target_sectors: "",
  number_of_deals: "",
  target_deal_size: "",
  primary_secondary: "",
  speed_of_deployment: "",
  target_company_size: "",
  portfolio_company_profile: "",
  typical_stake_in_portfolio_companies: ""
}

export interface IfInvestmentLimits {
  leverage: string,
  derivatives: string,
  geographic_area: string,
  max_issuer_limit: string,
  max_sector_limit: string,
  esg_considerations: string,
  excluded_profiles: string,
  max_country_limit: string
  interest_coverage_ratio: string
}

export const defaultIfInvestmentLimits: IfInvestmentLimits = {
  leverage: "",
  derivatives: "",
  geographic_area: "",
  max_issuer_limit: "",
  max_sector_limit: "",
  esg_considerations: "",
  excluded_profiles: "",
  max_country_limit: "",
  interest_coverage_ratio: ""
}

export interface IfPrivateDebtExtraInfo {
  irr: IfIrr,
  other: IfOther,
  overview: IfOverview,
  fund_terms: IfFundTerms,
  characteristics: IfPrivateDebtCharacteristics,
  investment_limits: IfInvestmentLimits
}

export const defaultIfPrivateDebtExtraInfo: IfPrivateDebtExtraInfo = {
  irr: defaultIfIrr,
  other: defaultIfOther,
  overview: defaultIfOverview,
  fund_terms: defaultIfFundTerms,
  characteristics: defaultIfPrivateDebtCharacteristics,
  investment_limits: defaultIfInvestmentLimits
}

export interface IfPrivateEquityExtraInfo {
  irr: IfIrr,
  other: IfOther,
  overview: IfOverview,
  fund_terms: IfFundTerms,
  characteristics: IfPrivateEquityCharacteristics,
  investment_limits: IfInvestmentLimits
}

export const defaultIfPrivateEquityExtraInfo: IfPrivateEquityExtraInfo = {
  irr: defaultIfIrr,
  other: defaultIfOther,
  overview: defaultIfOverview,
  fund_terms: defaultIfFundTerms,
  characteristics: defaultIfPrivateEquityCharacteristics,
  investment_limits: defaultIfInvestmentLimits
}


// COLLECTABLE CARS
export interface Appraisals {
  date: string,
  value: string
  //docs : FileSrc[]
}

export const defaultAppraisals: Appraisals = {
  date: "",
  value: "",
  //docs : []
}

export interface Odometer {
  odometer_value: string,
  odometer_unit: string
}

export const defaultOdometer: Odometer = {
  odometer_value: "",
  odometer_unit: ""
}

export interface CarExtraInfo {
  //asset_title: string,
  name: string,
  description: string,
  year: number,
  make: string,
  model: string,
  vin: string,
  exterior_color: string,
  interior_color: string,
  odometer: Odometer,
  transmission: string,
  engine_type: string,
  engine_size: string,
  location: string,
  market_value: string,
  condition: string,
  appraisals: Appraisals[],

}

export const defaultCarExtraInfo: CarExtraInfo = {
  //asset_title: "",
  name: "",
  description: "",
  year: 0,
  make: "",
  model: "",
  vin: "",
  exterior_color: "",
  interior_color: "",
  odometer: defaultOdometer,
  transmission: "",
  engine_type: "",
  engine_size: "",
  location: "",
  market_value: "",
  condition: "",
  appraisals: [],

}

// FIXED INCOME EXTRA INFO

export interface FixedIncomeExtraInfo {
  // Issuer information
  issuer_legal_name: string
  lei: string
  jurisdiction: string
  sector: string
  description: string
  credit_rating: string
  // Bond information
  bond_name: string
  isin: string
  currency: string
  nominal_value_per_token: string
  total_issue_size: string
  use_of_proceeds: string
  coupon_rate: string
  coupon_type: string
  payment_frequency: string
  issue_price: string
  yield_issue: string
  settlement_date: string
  issue_date: string
  maturity_date: string
  redemption: string
  rank: string
  // Legal Details
  governing_law: string
  prospectus: string
  tax_info: string
  subscription_term: string
  settlement_system: string
  transfer_restriction: string
  // Security Package
  collateral_assets: string
  security_agent: string
  affirmative_covenants: string
  negative_covenants: string
  esg_covenants: string
  collateral_substitution: string
  enforcement_mechanism: string
  // ESG
  green_bond_label: string
  second_party_opinion: string
  certification_reference: string
  impact_metrics: string
}

export const defaultFixedIncomeExtraInfo: FixedIncomeExtraInfo = {
  issuer_legal_name: '',
  lei: '',
  jurisdiction: '',
  sector: '',
  description: '',
  credit_rating: '',
  bond_name: '',
  isin: '',
  currency: '',
  nominal_value_per_token: '',
  total_issue_size: '',
  use_of_proceeds: '',
  coupon_rate: '',
  coupon_type: '',
  payment_frequency: '',
  issue_price: '',
  yield_issue: '',
  settlement_date: '',
  issue_date: '',
  maturity_date: '',
  redemption: '',
  rank: '',
  governing_law: '',
  prospectus: '',
  tax_info: '',
  subscription_term: '',
  settlement_system: '',
  transfer_restriction: '',
  collateral_assets: '',
  security_agent: '',
  affirmative_covenants: '',
  negative_covenants: '',
  esg_covenants: '',
  collateral_substitution: '',
  enforcement_mechanism: '',
  green_bond_label: '',
  second_party_opinion: '',
  certification_reference: '',
  impact_metrics: ''
}

// MEDIA

export interface FileSrc {
  name: string,
  uploaded: boolean,
  src: string,
  small?: string,
  index?: number,
  filename_big?: string,
  filename_small?: string
}

export const defaultFileSrc: FileSrc = {
  name: "",
  uploaded: false,
  src: ""
}

export const AssetContext = createContext<Asset>(defaultAsset)
export const useAssetContext = () => useContext(AssetContext)

